import { render } from "./ERC20Wallet.vue?vue&type=template&id=fa90acd0&scoped=true"
import script from "./ERC20Wallet.vue?vue&type=script&lang=js"
export * from "./ERC20Wallet.vue?vue&type=script&lang=js"

import "./ERC20Wallet.vue?vue&type=style&index=0&id=fa90acd0&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa90acd0"]])

export default __exports__